(function() {
    var ui = fpUtil.getNamespace('ui', fp),
        closeTimeoutMs = 50;
    ui.Dropdown = fp.Component.extend({
        construct: function(element, config, template, parent) {
            this.$list = $();

            if (_.isFunction(config)) config = {
                onAfterChange: config
            };
            else if (!_.isObject(config)) config = {};

            _.defaults(config, {
                autoInit: true,
                onOpen: $.noop,
                onClose: $.noop,
                onChange: $.noop,
                onAfterChange: $.noop
            });

            var $element = $(element);
            $element.data('fp.ui.Component', this);

            if (!(template || config.template) && $element.hasClass('fp-dropdown')) {
                template = $element;
            }

            if (!template) {
                this.__prepareForDestroy();
                return;
            }

            this._super(element, config, template, parent);

            this.isOpen = false;

            var self = this;

            this.__close = function(event) {
                self.close(0);
            };

            if(!config.container && $element.closest('.fp-product-carousel, .fp-scroll-list-x').length) {
                config.container = 'dropdown-container';
            }

            if (config.container) self.scope.option = {
                container: config.container
            };

            this.init();
        },
        render: function(params) {
            this._super(params);

            var self = this,
                $element = this.$element,
                $label = $element.closest('label'),
                $menu = $element.find('> .fp-dropdown-menu'),
                $button = $element.find('> .fp-dropdown-value'),
                $ulList = $element.find('> .fp-dropdown-value + .fp-dropdown-menu ul.fp-dropdown-list'),
                buttonAttrs = {
                    id: 'fp-dropdown-value-' + this.id,
                    'aria-haspopup': 'listbox',
                    'role': 'combobox',
                    'aria-expanded': 'false',
                    'aria-owns': 'fp-dropdown-menu-' + this.id
                }

            if(this.config.ariaLabel) {
                buttonAttrs['aria-label'] = this.config.ariaLabel;
            }
            else if($label.length) {
                var labelId = $label.attr('id');
                if(!labelId) {
                    labelId = 'fp-dropdown-label-' + this.id;
                    $label.attr('id', labelId);
                }
                buttonAttrs['aria-labelledby'] = labelId;
            }
            
            $button.attr(buttonAttrs);

            if (this.scope.multiple) {
                $element.prop('class', $element.prop('class').replace('fp-dropdown', 'fp-dropdown fp-dropdown-multiple'));
            }

            $ulList
            .attr({
                role: 'listbox'
            });

            $menu
                .attr({
                    id: 'fp-dropdown-menu-' + this.id 
                    //role: 'listbox'
                })
                .find('.fp-dropdown-list-item > a')
                .each(function() {
                    $(this).attr({
                        id: 'fp-dropdown-list-item-' + _.uniqueId(),
                        role: 'option'
                    });
                });

            $element
                .off()
                .on('blur', '> .fp-dropdown-value', $.proxy(self.close, self))
                .on('mousedown', '> .fp-dropdown-value', function(event) {
                    //prevent blur
                    event.preventDefault();
                })
                .on('click', '> .fp-dropdown-value', function(event) {
                    //if click was not triggered by a mouse/touch event, toggle
                    if(event.detail) {
                        event.preventDefault();
                        //event.stopImmediatePropagation();

                        clearTimeout(self.closeTimerId);
                        if (self.isOpen) {
                            self.close(0);
                            return;
                        }

                        //because default is prevented above, we need to manually focus
                        $element.find('> .fp-dropdown-value').focus();
                        self.open();
                    }
                })
                .on('keydown', '> .fp-dropdown-value', function(event) {
                    //prevent scrolling of window when dropdown is open and up/down key is pressed
                    var keycodes = fpConstants.keycode;
                    switch (event.keyCode) {
                        case keycodes.UP:
                        case keycodes.DOWN:
                            event.preventDefault();
                            break;
                        case keycodes.TAB:
                            self.close(0);
                            break;
                    }
                })
                .on('keyup', '> .fp-dropdown-value', function(event) {
                    event.preventDefault();

                    var keycodes = fpConstants.keycode,
                        $currentTarget = $element.data('currentTarget');

                    switch (event.keyCode) {
                        case keycodes.ESC:
                            if (self.isOpen) {
                                clearTimeout(self.closeTimerId);
                                self.close(0);
                            }
                            break;
                        case keycodes.RETURN:
                        case keycodes.SPACE:
                            if (self.isOpen) {
                                clearTimeout(self.closeTimerId);
                                if($currentTarget) self.__setSelected($($currentTarget));
                                self.close(0);
                            }
                            else self.open();

                            break;
                        case keycodes.UP:
                        case keycodes.DOWN:
                            if (!$element.hasClass('fp-is-dropdown-open')) {
                                self.open();
                                return;
                            }
                            if (self.$list.length < 2) return;
                            
                            $currentTarget.removeClass('fp-is-active');
                            var $nextItem = $currentTarget.parent();
                            if (!$nextItem.length) $nextItem = self.$list.first().parent();
                            else {
                                if(event.keyCode == keycodes.UP) {
                                    $nextItem = $nextItem.prev('.fp-dropdown-list-item');
                                    if(!$nextItem.length) $nextItem = self.$list.last().parent();
                                }
                                else {
                                    $nextItem = $nextItem.next('.fp-dropdown-list-item');
                                    if(!$nextItem.length) $nextItem = self.$list.first().parent();
                                }
                            }

                            if ($nextItem.length) {
                                var $item = $nextItem.find('> a').addClass('fp-is-active');
                                $currentTarget = $item;
                                $element.data('currentTarget', $currentTarget);
                                // self.__setSelected($item);
                                $button.attr('aria-activedescendant', $item.attr('id'));
                                var $list = $item.closest('.fp-dropdown-list');
                                $list.scrollTop($item.position().top + $list.scrollTop() - ($list.parent().height() - $item.height()) * 0.5);
                            }
                            break;
                        default:
                            var startText = event.keyCode ? String.fromCharCode(event.keyCode) : '';
                            if (startText && fpUtil.regExp.matchAlphanumeric.test(startText)) {
                                self.__setSelectedByStartText(startText);
                            }
                    }
                });

            this.__applyContainerEvents();

            if (this.config.enabled != undefined && !this.config.enabled) {
                $element.addClass('fp-dropdown-disabled');
                $element.off('click');
            }

            if (fp.msie() > 0) {
                $menu.find('> .fp-dropdown-list')
                    .off()
                    .on('scroll', function() {
                        clearTimeout(self.closeTimerId);
                        $element.find('> .fp-dropdown-value').focus();
                    });
            }

            this.$list = $menu.find('.fp-dropdown-list > li:not(.fp-dropdown-list-toggle-check-all), .fp-dropdown-list > span:not(.fp-dropdown-list-toggle-check-all)').find('a');

            if (this.config.value) {
                if (!_.isArray(this.config.value)) this.setValue(this.config.value);
                else this.setValues(this.config.value);
            }
            else {
                var value = S.getString(this.getValue());
                if (!value.length) {
                    value = $element.find('> input[type="hidden"]').first().val();

                    if (value) this.setValue(value);
                    else this.__setSelected(this.$list.filter('[data-selected="true"]'), true);
                }
            }
        },
        getValue: function() {
            return this.value;
        },
        setValue: function(value) {
            value = S.getString(value);

            if (!value.length) {
                this.__setSelected(null, true);
                return;
            }

            var self = this,
                $this,
                thisValue;

            this.$list.each(function() {
                $this = $(this);
                thisValue = fpUtil.decodeForHtml($this.attr('data-value') || $this.text());
                if (S(thisValue).eq(value, true)) {
                    self.__setSelected($this, true);
                    return false;
                }
            });
        },
        setValues: function(values) {
            if (!values || values.length == 0) return;
            this.$list.each(function() {
                $this = $(this);
                thisValue = fpUtil.decodeForHtml($this.attr('data-value') || $this.text());
                var found = $.grep(values, function(value) {
                    return thisValue == value;
                });
                if (found.length > 0) this.__setSelected($this, true);
            });
        },
        getSelectedItem: function() {
            return this.$list.filter('.fp-is-selected');
        },
        open: function() {
            var scope = this.scope,
                $element = this.$element,
                $button = $element.find('.fp-dropdown-value');

            if (scope.option && scope.option.container) {
                var $container = fp.__$freshop.find(fpUtil.formatString('[data-role="{0}"]', scope.option.container)),
                    $dropdownList = $element.find('.fp-dropdown-menu'),
                    position = $element.find('.fp-dropdown-value').offset();

                $dropdownList.data('parent', $element);

                // $container.children().each(function() {
                //     var $this = $(this),
                //         $parent = $this.data('parent');

                //     if($parent.length) $parent.append($this);
                //     else $this.remove();
                // });

                $dropdownList.appendTo($container);

                if(this.config.containerClass) $container.addClass(this.config.containerClass);
                $container
                    .css({
                        top: position.top + $button.outerHeight(),
                        left: position.left,
                        width: $button.outerWidth()
                    });

                this.__applyContainerEvents($container);
            }

            clearTimeout(this.closeTimerId);

            if (!this.$list.length) return;
            if ($element.hasClass('fp-dropdown-disabled')) return;

            fp.trigger(fp.events.DROPDOWN_CLOSE);

            if (this.isOpen) return;

            this.isOpen = true;
            $element.addClass('fp-is-dropdown-open');
                
            $(document.body).addClass('fp-is-dropdown-open');

            $(window).on('resize.dropdown.' + this.id, this.__close);
            fp.on(fp.events.DROPDOWN_CLOSE, this.__close);

            var $item = this.getSelectedItem(),
                $currentTarget = $element.data('currentTarget');

            if ($item.length) {
                $element.data('startItem', $item[0]);

                var $list = $item.closest('.fp-dropdown-list');
                $list.scrollTop($item.position().top + $list.scrollTop() - ($list.parent().height() - $item.height()) * 0.5);
                $currentTarget = $item;
            }

            if($currentTarget) $currentTarget.removeClass('fp-is-active');
            else $currentTarget = this.$list.first();
            $currentTarget.addClass('fp-is-active');
            $element.data('currentTarget', $currentTarget);

            $button.attr({
                'aria-expanded': 'true',
                'aria-activedescendant': $currentTarget.attr('id')
            });

            this.config.onOpen.call($element[0], this.value);
        },
        close: function(ms) {
            // if(fp.isLocal()) return;

            var self = this,
                scope = this.scope;

            if (!this.isOpen) return;

            if (scope.option && scope.option.container) {
                var $container = fp.__$freshop.find(fpUtil.formatString('[data-role="{0}"]', scope.option.container)),
                    $children = $container.find('.fp-dropdown-menu');

                if(this.config.containerClass) $container.removeClass(this.config.containerClass);

                $children.each(function() {
                    var $this = $(this);
                    if ($this.data('parent') == self.$element) {
                        self.$element.append($this);
                        if ($children.length == 1) {
                            $container.off().css({
                                top: '',
                                left: '',
                                width: ''
                            });
                        }
                        return false;
                    }
                });
            }

            if (fpConfig.enableQtyDropDown) {
                var $selectedItem = self.$element.find('[data-selected="true"]');
                if ($selectedItem.attr('data-value') == '0') {
                    $selectedItem.attr('data-selected', false);
                    self.$element.find('.fp-dropdown-list > li:first-child').find('> a').attr('data-selected', true);
                }
            }

            ms = fpUtil.isInteger(ms) ? ms : closeTimeoutMs;
            clearTimeout(this.closeTimerId);

            if (ms) this.closeTimerId = setTimeout(close, ms);
            else close();

            function close() {
                if (!self.isOpen) return;

                var $element = self.$element;
                self.isOpen = false;

                clearTimeout(self.clearCurrentTargetTimeout);
                self.clearCurrentTargetTimeout = setTimeout(function() {
                    var $currentTarget = $element.data('currentTarget');
                    if($currentTarget) $currentTarget.removeClass('fp-is-active');
                    $element.removeData('currentTarget lastSearchIndex');
                }, closeTimeoutMs);

                // $(window).off('resize.dropdown.' + self.id, self.__close);
                // fp.off(fp.events.DROPDOWN_CLOSE, self.__close);

                $(document.body).removeClass('fp-is-dropdown-open');
                $element.removeClass('fp-is-dropdown-open');
                $element.find('> .fp-dropdown-value')
                    .attr({
                        'aria-activedescendant': '',
                        'aria-expanded': false
                    });

                var startItem = $element.data('startItem');
                $element.removeData('startItem');
                if (startItem == undefined || startItem != self.getSelectedItem()[0]) {
                    self.config.onAfterChange.call($element[0], self.value);
                }

                self.config.onClose.call(self.$element[0], self.value);
            }
        },
        destroy: function(persistUI) {
            this.config.onOpen = $.noop;
            this.config.onClose = $.noop;
            this.config.onAfterChange = $.noop;
            this.config.onChange = $.noop;
            this.close(0);
            if(!persistUI) this.setValue();

            // $(window).off('resize.dropdown.' + this.id, this.__close);
            // fp.off(fp.events.DROPDOWN_CLOSE, this.__close);

            this.$element
                .removeData('fp.ui.Component')
                .off();

            this.$element.find('> .fp-dropdown-menu > .fp-dropdown-list')
                .off()
                .find('> li:not(.fp-dropdown-list-toggle-check-all), > span:not(.fp-dropdown-list-toggle-check-all)').find('a').off();

            this._super(persistUI);
        },
        onChange: function() {
            this.config.onChange.call(this.$element[0], this.value);
        },
        __applyContainerEvents: function($container) {
            if (!$container) $container = this.$element;
            var self = this;

            $container
                .on('mousedown', '> .fp-dropdown-menu > .fp-dropdown-list', function(event) {
                    //prevent blur
                    event.preventDefault();

                    if (fp.msie() > 0) {
                        //in IE mousedown event is triggered before blur so set timeout to cancel the close
                        setTimeout(function() {
                            clearTimeout(self.closeTimerId);
                        }, closeTimeoutMs * 0.5);
                    }
                })
                .on('focus', '> .fp-dropdown-menu > .fp-dropdown-list > li a, > .fp-dropdown-menu > .fp-dropdown-list > span a', function(event) {
                    clearTimeout(self.closeTimerId);
                    //if(self.scope.multiple) return;

                    $container.find('> .fp-dropdown-value').focus();
                })
                .on('click', '> .fp-dropdown-menu > .fp-dropdown-list > li a, > .fp-dropdown-menu > .fp-dropdown-list > span a', function(event) {
                    event.preventDefault();
                    if (self.scope.multiple) event.stopImmediatePropagation();

                    self.__setSelected($(this));
                    self.close(0);
                })
                .on('mouseover', '> .fp-dropdown-menu > .fp-dropdown-list > li a, > .fp-dropdown-menu > .fp-dropdown-list > span a', function(event) {
                    if (!fp.device.usingMouse) return;
                    $currentTarget = $container.data('currentTarget');
                    if($currentTarget) $currentTarget.removeClass('fp-is-active');
                    $container.data('currentTarget', $(this));
                });
        },
        __setSelected: function($item, isInit) {
            var self = this,
                text,
                selectedValue;

            if ($item) {
                if (_.isString($item)) text = selectedValue = $item;
                else if (fpUtil.isJQuery($item) && $item.length) {
                    if (!fpUtil.getBoolean($item.attr('data-selectable'), true)) return;

                    var prevItem,
                        multiple = this.scope.multiple;

                    selectedValue = fpUtil.decodeForHtmlAttribute($item.attr('data-value'));

                    if (multiple) {
                        var $groupItem, isSelected, toggleAll = (selectedValue == 'check-all' || selectedValue == 'uncheck-all'),
                            $items, updateSelected = true;

                        if (selectedValue == 'check-all') isSelected = true;
                        else if (selectedValue == 'uncheck-all') isSelected = false;
                        else isSelected = this.__toggleSelectedItem($item);

                        if (toggleAll) $items = this.$list;
                        else if ($item.parent().hasClass('fp-dropdown-list-group')) $items = this.$list.filter('[data-group-id="' + selectedValue + '"]');
                        else {
                            updateSelected = false;
                            $items = this.$list.filter('[data-selected=true]');
                        }

                        selectedValue = '';
                        text = '';

                        $items.each(function() {
                            $groupItem = $(this);
                            isSelected = (!updateSelected ? fpUtil.getBoolean($groupItem.attr('data-selected'), false) : isSelected);

                            if (isSelected) {
                                if (selectedValue) {
                                    text += ', ';
                                    selectedValue += ',';
                                }
                                text += $groupItem.html();
                                selectedValue += fpUtil.decodeForHtmlAttribute($groupItem.attr('data-value'));
                            }

                            if (updateSelected) self.__toggleSelectedItem($groupItem, isSelected);
                        });
                    }
                    else {
                        text = $item.find('> font > font').html() || $item.html();

                        this.$list.each(function() {
                            var $this = $(this);
                            if ($this.attr('data-selected')) prevItem = this;
                            self.__toggleSelectedItem($this, false);
                        });

                        this.__toggleSelectedItem($item, true);
                    }

                    selectedValue = selectedValue.length > 0 ? selectedValue : text;
                }
            }

            var dataDefault = fpUtil.decodeForHtmlAttribute(this.$element.attr('data-default'));
            if (!text) text = selectedValue = dataDefault;
            var $value = this.$element.find('> .fp-dropdown-value .fp-value').html(text);

            fpUtil.regExp.matchTag.lastIndex = 0;
            $value.parent().attr('aria-label', S(text.replace(fpUtil.regExp.matchTag, '')).trim().s + fp.ui.locale('aria-label-dropdown-site-category', ' selected. Expand to select more options'));

            $value
                .toggleClass('fp-has-option-attribute', $value.find('.fp-option-attribute').length > 0);

            if (dataDefault != fpUtil.decodeForHtmlAttribute(selectedValue)) {
                this.$element.addClass('fp-has-value');
            }
            else {
                selectedValue = '';
                this.$element.removeClass('fp-has-value');
            }

            var $input = this.$element.find('> input[type="hidden"]').val(selectedValue);
            this.value = selectedValue;
            if(!isInit && (!$item || ($item && $item[0] != prevItem))) {
                $input.trigger('change');
                this.onChange();
            }
        },
        __setSelectedByStartText: function(startText, endIndex) {
            if (!this.$list.length) return;

            var selectedItem = fpUtil.isNull(endIndex) ? this.getSelectedItem()[0] : null,
                lastSearchIndex = this.$element.data('lastSearchIndex') || 0,
                startIndex = lastSearchIndex;
            endIndex = endIndex || this.$list.length - 1;

            for (var n = lastSearchIndex; n <= endIndex; n++) {
                $item = $(this.$list[n]);
                if (startIndex == 0 && selectedItem) {
                    if (selectedItem == $item[0]) {
                        selectedItem = null;
                        startIndex = n;
                        n++;
                        $item = $(this.$list[n]);
                    } else continue;
                }

                if (S($item.text()).trim().startsWith(startText, true)) {
                    this.__setSelected($item);
                    var $list = $item.closest('.fp-dropdown-list');
                    $list.scrollTop($item.position().top + $list.scrollTop() - ($list.parent().height() - $item.height()) * 0.5);
                    this.$element.data('lastSearchIndex', n + 1);
                    return;
                }
            }

            this.$element.removeData('lastSearchIndex');
            if (startIndex > 0) this.__setSelectedByStartText(startText, startIndex - 1);
        },
        __toggleSelectedItem: function($item, isSelected) {
            isSelected = isSelected != null ? isSelected : !fpUtil.getBoolean($item.attr('data-selected'), false);
            if (isSelected) {

                $item
                    .addClass('fp-is-selected')
                    .attr({
                        'data-selected': true,
                        'aria-selected': true
                    });
            }
            else {
                $item
                    .removeClass('fp-is-selected')
                    .removeAttr('data-selected aria-selected');
            }
            return isSelected;
        }
    });
})();